export default __webpack_public_path__ + "static/media/download.7f9bfbe5.svg";